module.exports = __webpack_public_path__ + "img/stickerrounded.c9f2073f.webp";